// Copy the social area's screens and components added while moving to the design system (src/ui).
// One entry per locale; every key exists in all seven (nl is the source, the rest are translations).
export const socialCopy = {
  nl: {
    "social.b.refresh": "Vernieuwen",
  },
  en: {
    "social.b.refresh": "Refresh",
  },
  de: {
    "social.b.refresh": "Aktualisieren",
  },
  fr: {
    "social.b.refresh": "Actualiser",
  },
  es: {
    "social.b.refresh": "Actualizar",
  },
  it: {
    "social.b.refresh": "Aggiorna",
  },
  pt: {
    "social.b.refresh": "Atualizar",
  },
} as const;
